<style scoped>
  .info-list-table {
    border: 1px black solid;
    width: 100%;
  }

  .num1 {
    font-size: 40px;
    /*color:#027DB4;*/
    font-weight: 600;
  }

  .num2 {
    color: #027DB4;
  }

  .title-blue {
    background: #4187ff;
    color: white;
    height: 50px;
    text-align: left;
    /*align-items: center;
    display: flex;*/
  }

  .title-blue > div {
    padding: 13px 20px 10px 20px;
  }

  .round-grey {
    background: #F0F0F0;
    border: 1px #F0F0F0 solid;
    border-radius: 25px;
    margin-bottom: 20px;
    height: 40px;
    padding: 7px;

  }

  .round-blue {
    background: #E9F0FC;
    color: #5189F6;
    padding: 10px;
    margin: 0 10px 0 10px;
    border-radius: 10px;
    text-align: left;
    font-weight: 500;
  }

  .row-grey245 {
    background: #F5F5F5;
    height: 10px;
  }

  .row-white {
    padding: 10px;
    border-bottom: 1px solid #EEEEEE;
    margin: 0 10px 0 10px;
    text-align: left;
  }

  .arrow {
    color: white;
    margin-top: 3px;
    font-size: 10px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -moz-transform: rotate(90deg); /* Firefox */
    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
    -o-transform: rotate(90deg); /* Opera */
  }
</style>
<template>
  <div>
    <van-row>
      <!--<van-cell title="选择单个日期"   :value="date" @click="show = true" />-->
      <van-calendar v-model="show" :default-date="vantDate.defaultDate" :min-date="vantDate.minDate" color="#409EFF"
                    @confirm="onConfirm"/>
      <van-col span="24" class="title-blue">
        <div>
          <span>{{detectionDep.detectionDepName}}</span>
          <span style="float: right" @click="show=true">{{date}}
            <van-icon name="play" style="float: right" class="arrow"/>
        </span>

        </div>
      </van-col>
      <van-col style="margin-top: 20px" span="24">
        <span>已执行/已预约</span>
      </van-col>
      <van-col span="24">
        <span class="num1">{{sumResults.totalExecutedNumbers}}/{{sumResults.totalNumbers}}</span>
      </van-col>
      <van-col span="8" offset="8" class="round-grey">
        执行率:
        <span class="num2">{{sumResults.totalRate}}</span>
      </van-col>
    </van-row>

    <van-row class="round-blue">
      <van-col span="10" style="text-align: left">
        预约项目
      </van-col>
      <van-col span="4">
        上午
      </van-col>
      <van-col span="4">
        下午
      </van-col>
      <van-col span="6">
        全天执行率
      </van-col>
    </van-row>

    <template v-for="(item,index) in appointmentList ">
      <van-row class="row-white" @click="goDepartmentDetail(item.bookItemId,item.bookItemName)">
        <van-col span="10" style="text-align: left">
          {{item.bookItemName}}
        </van-col>
        <van-col span="4">
          {{item.morningExecutedNumbers}}/{{item.morningAppointmentNumbers}}
        </van-col>
        <van-col span="4">
          {{item.afternoonExecutedNumbers}}/{{item.afternoonAppointmentNumbers}}
        </van-col>
        <van-col span="5" style="text-align: center">
          {{item.executedRate}}
        </van-col>
        <van-col span="1" style="text-align: center">
          <van-icon name="arrow" style="padding-top: 2px"/>
        </van-col>
      </van-row>
    </template>

    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>

    <van-row style="padding: 10px;margin: 0 10px 0 10px" @click="patientSearch">
      <van-col span="12" style="text-align: left">预约患者搜索</van-col>
      <van-col span="12" style="text-align: right">
        <van-icon name="arrow"/>
      </van-col>
    </van-row>

    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>


  </div>
</template>

<script>
  // 通过export default导入 这里allTest这个变量名是可以随便写的,因为export default有且只有一个
  import api from "@/axios/api";
  import { mapGetters, mapActions } from "vuex";
  // name随便写 反正default只有一个
  export default {
    name: 'department-info',
    computed: {
      ...mapGetters(["token"])
    },
    watch: {
      token: {
        immediate: true,
        handler: function(val) {
          if (val) {
            this.getDetectionDep();
          }
        }
      }
    },
    data() {
      return {
        //全科室 总人数/已执行 预约率  此项数据从url中获取
        sumResults: {
          totalNumbers: '',
          totalExecutedNumbers: '',
          totalRate: '',
        },
        //从院长别页面带入数据
        detectionDep: {
          detectionDepId: this.$route.query.detectionDepId,
          detectionDepName: '',
          precise: '',
        },
        info: '',
        //字符串类型日期
        date: this.$route.query.bookTime,
        //Calendar日历控件
        vantDate: {
          //默认时间 van日历控件只支持date类型参数
          defaultDate: new Date(Date.parse(this.$route.query.bookTime.replace(/-/g, "/"))),
          //可选择最小时间
          minDate: new Date(Date.parse('1970-01-01'.replace(/-/g, "/")))
        },
        //日期控件默认隐藏
        show: false,
        appointmentList: []

      }
    },
    created: function () {
      this.getDetectionDep();
    },
    methods: {
      formatDate(date) {
        return date.toLocaleDateString().replace(/\//g, '-');
      },
      //弹出日期控件
      onConfirm(date) {
        this.show = false;
        this.date = this.formatDate(date);
        this.getDepartmentInfo();
      },
      //跳转到详情页
      goDepartmentDetail(bookItemId, bookItemName) {

        this.$router.push({
          path: '/departmentDetail',
          query: {
            bookTime: this.date,
            bookItemId: bookItemId,
            bookItemName: bookItemName,
            detectionDepId: this.detectionDep.detectionDepId,
            detectionDepName: this.detectionDep.detectionDepName,
            precise: this.detectionDep.precise
          }
        })
      },
      //获取预约项目别页面信息
      getDepartmentInfo() {
        //获取数据前先清空list,避免数据加载错误后数据有误
        this.sumResults = [];
        this.appointmentList = [];
        api.getDepartmentInfo(this.date, this.detectionDep.detectionDepId, this.detectionDep.precise).then(res => {
          this.appointmentList = res.lists;
          this.sumResults.totalNumbers = res.appointmentNumbers;
          this.sumResults.totalExecutedNumbers = res.todayExecutedCount;
          this.sumResults.totalRate = res.executed;
        });
      },
      //获取医技科室信息
      getDetectionDep() {
        api.getDetectionDep(this.detectionDep.detectionDepId).then(res => {
          this.detectionDep.detectionDepId = res.detection.id
          this.detectionDep.detectionDepName = res.detection.name
          this.detectionDep.precise = res.detection.precise
          this.getDepartmentInfo();
        });

      },
      //跳转到患者搜索页 全院级别  入参bookTime
      patientSearch() {
        this.$router.push({
          path: '/directorDetail',
          query: {
            bookTime: this.date,
            detectionDepId: this.detectionDep.detectionDepId,
            precise: this.detectionDep.precise
          }
        })
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/hospital-admin/pages/department-info.vue